import Modal from "react-modal";

function ImgModal(props) {
    return (
        <Modal isOpen={props.open.open} onRequestClose={() => props.setOpen(false)}>
            <img className="enlarged" onClick={() => props.setOpen(false)} src={props.open.imgSrc} alt="Full Size" />
        </Modal>
    );
};

export default ImgModal;